var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{ref:"el",attrs:{"name":"collapse"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"leave":_vm.leave}},[_vm._t("default",[_vm._v("\n    //\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }